export default class CreateClientViewmodel {
    public name: string = '';
    public logo: File[] | null = null;
    public alertThreshold: string = '';
}